var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3641",
    fillRule: "evenodd",
    d: "M15.1716035,12.7573899 L18.7071068,16.2928932 L17.2928932,17.7071068 L13.7573899,14.1716035 C12.9669569,14.6951232 12.0190823,15 11,15 C8.23857625,15 6,12.7614237 6,10 C6,7.23857625 8.23857625,5 11,5 C13.7614237,5 16,7.23857625 16,10 C16,11.0190823 15.6951232,11.9669569 15.1716035,12.7573899 Z M11,13 C12.6568542,13 14,11.6568542 14,10 C14,8.34314575 12.6568542,7 11,7 C9.34314575,7 8,8.34314575 8,10 C8,11.6568542 9.34314575,13 11,13 Z"
  })));
};
export default SvgSearch;